import axios from 'axios'

export default {
  async getOneByAccessToken() {
    return axios.get(`/users/by-access-token`)
  },

  async updateSectionRecords(payload) {
    return axios.patch(`/users/section-records`, payload)
  },

  async updateQuizString(payload) {
    return axios.patch(`/users/quiz-string`, payload)
  },

  async fetchHappyUsers() {
    return axios.get(`/users/count`)
  }
}
